<template>
  <Input v-bind="$attrs" :type="revealed ? 'text' : 'password'" v-model="model">
    <template #suffix>
      <IconButton
        type="button"
        variant="ghost"
        size="small"
        :icon="revealed ? 'eye-off' : 'eye'"
        :aria-label="revealed ? 'Hide password' : 'Show password'"
        @click="toggleReveal"
      />
    </template>
  </Input>
</template>

<script setup lang="ts">
import { onUnmounted, ref } from 'vue';

import IconButton from './icon-button.vue';
import Input from './input.vue';

defineOptions({ inheritAttrs: false });

// A reveal is a glance-check, not a mode: it hides itself again so a password
// can't stay readable on a screen the user walked away from
const autoHideMs = 5000;

const model = defineModel<string>({ default: '' });

const revealed = ref(false);
let hideTimer: ReturnType<typeof setTimeout> | undefined;

function toggleReveal() {
  revealed.value ? hide() : reveal();
}

function reveal() {
  revealed.value = true;
  hideTimer = setTimeout(hide, autoHideMs);
}

function hide() {
  revealed.value = false;
  clearTimeout(hideTimer);
}

onUnmounted(() => clearTimeout(hideTimer));
</script>
